var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('com-h1',{attrs:{"title":_vm.$store.state.isPastHot === 1 ? '往届热门议题' : '热门议题'}}),_c('com-swipe',{attrs:{"items":_vm.appliededHotLecturesArr}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }